import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchJkBankAccounts = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.regionId != null) qs.append("regionId", params.regionId);
  if (params.activeOnly != null) qs.append("activeOnly", params.activeOnly);
  const query = qs.toString();
  const url = query
    ? `${ENDPOINTS.JK_BANK_ACCOUNT.LIST}?${query}`
    : ENDPOINTS.JK_BANK_ACCOUNT.LIST;
  return apiClient(url, { method: "GET" });
};

export const fetchJkBankAccountById = (id) => {
  return apiClient(ENDPOINTS.JK_BANK_ACCOUNT.BY_ID(id), { method: "GET" });
};

export const lookupJkBankAccount = (accountNumber) => {
  return apiClient(ENDPOINTS.JK_BANK_ACCOUNT.LOOKUP(accountNumber), {
    method: "GET",
  });
};

export const createJkBankAccount = (data) => {
  return apiClient(
    ENDPOINTS.JK_BANK_ACCOUNT.CREATE,
    { method: "POST", body: data },
    { headers: { "Content-Type": "application/json" } }
  );
};

export const updateJkBankAccount = (id, data) => {
  return apiClient(ENDPOINTS.JK_BANK_ACCOUNT.UPDATE(id), {
    method: "PUT",
    body: { id, ...data },
  });
};

export const deactivateJkBankAccount = async (id) => {
  await apiClient(ENDPOINTS.JK_BANK_ACCOUNT.DEACTIVATE(id), {
    method: "DELETE",
  });
  return id;
};
